import axios from 'axios';

const API_BASE_URL = 'https://meusservicospro.com.br/api';

/**
 * Comprime a imagem antes de fazer upload para otimizar performance
 */
const compressImage = (file, maxWidth = 1920, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    // Ignora SVG, GIF e outros tipos que não sejam jpeg/png/webp
    if (!file.type.match(/image\/(jpeg|png|webp)/)) {
      return resolve(file);
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Se for PNG original mantém PNG, caso contrário converte pra JPEG para melhor compressão
        const mimeType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
        
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error('Erro ao converter imagem no canvas'));
            const compressedFile = new File([blob], file.name, {
              type: mimeType,
              lastModified: Date.now(),
            });
            resolve(compressedFile);
          },
          mimeType,
          quality
        );
      };
      img.onerror = (err) => reject(err);
    };
    reader.onerror = (err) => reject(err);
  });
};

export const uploadToServer = async (file, folder = 'apps') => {
  try {
    // Comprime a imagem antes de subir
    const optimizedFile = await compressImage(file);
    
    const formData = new FormData();
    formData.append('image', optimizedFile);
    formData.append('folder', folder);

    const response = await axios.post(`${API_BASE_URL}/upload.php`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log(`Upload progress: ${percentCompleted}%`);
      },
    });

    // Ajuste para a estrutura de resposta do PHP
    if (response.data.success) {
      return response.data.data.fileUrl;
    } else {
      throw new Error(response.data.message || 'Falha no upload');
    }
  } catch (error) {
    console.error('Erro no upload:', error);
    
    // Mensagem de erro mais específica
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else if (error.message) {
      throw new Error(error.message);
    } else {
      throw new Error('Falha no upload da imagem. Verifique a conexão.');
    }
  }
};

export const deleteFromServer = async (fileUrl) => {
  try {
    console.log('Arquivo para deletar:', fileUrl);
    return true;
  } catch (error) {
    console.error('Erro ao deletar arquivo:', error);
    throw error;
  }
};